import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginActivateService } from './guards/login-activate.service';
import { RoleService } from './guards/role.service';
import { VersionDetailsComponent } from './modules/auth/components/version-details/version-details.component';

const routes: Routes = [
	{
		path: 'dashboard',
		loadChildren: () =>
			import('./modules/dashboard/dashboard.module').then((m) => m.DashboardModule),
		canActivate: [LoginActivateService, RoleService],
	},
	{
		path: 'login',
		loadChildren: () => import('./modules/auth/auth.module').then((m) => m.AuthModule),
	},
	{
		path: 'version',
		component: VersionDetailsComponent,
	},
	{ path: '', redirectTo: '/login', pathMatch: 'full' },
	{ path: '**', redirectTo: '/login' },
];

@NgModule({
	imports: [RouterModule.forRoot(routes)],
	exports: [RouterModule],
})
export class AppRoutingModule {}
